<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'TEAM.NEW' | translate }}</div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <form [formGroup]="form" class="form-grid">
      <div class="checkbox-field">
        <input type="checkbox" formControlName="external" id="external">
        <label for="external">Check if the user is external</label>
      </div>
      @if (!form.get('external').value) {
        <div class="info">
          <label>{{ 'TEAM.MEMBER' | translate }} ID</label>
          <df-input block formControlName="teamMemberId" />
        </div>
      }
      <div>
        <label>{{ 'TEAM.FIRST_NAME' | translate }}</label>
        <df-input block formControlName="teamMemberFirstName" />
      </div>
      <div>
        <label>{{ 'TEAM.LAST_NAME' | translate }}</label>
        <df-input block formControlName="teamMemberName" />
      </div>
      <div>
        <label>{{ 'TEAM.LANGUAGE' | translate }}</label>
        <df-input block formControlName="teamMemberLanguage" />
      </div>
      <div>
        <label>{{ 'TEAM.PHONE' | translate }}</label>
        <df-input block formControlName="teamMemberCellularPhone" />
      </div>
      <div>
        <label>{{ 'TEAM.EMAIL' | translate }}</label>
        <df-input block formControlName="teamMemberEmail" />
      </div>
      <div>
        <label>{{ 'TEAM.LOCATION' | translate }}</label>
        <df-select formControlName="peoplelocationcode"
            [options]="peopleLocations | selectOptions:'peoplelocationcode':'peoplelocationname'" />
      </div>
      <div>
        <label>{{ 'TEAM.MOBILE_DEVICE' | translate }}</label>
        <df-select formControlName="mobileDevicepk" [options]="mobileDeviceOptions" />
      </div>
    </form>

    <div class="footer">
      <df-button variant="primary" (onClick)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate }}</df-button>
    </div>
  </div>
</div>